export default __webpack_public_path__ + "media/grid/thumb-down_4x-a9ba60d7.png";